import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import type { ReactNode } from "react";

export function RadioGroup({
  className = "space-y-3",
  defaultValue,
  value,
  onValueChange,
  options,
}: {
  /** Tailwind spacing class applied to the root list. Defaults to "space-y-3". */
  className?: string;
  defaultValue?: string;
  /** Controlled value — pass when the parent tracks selection state. */
  value?: string;
  onValueChange?: (value: string) => void;
  options: Array<{ description?: ReactNode; label: ReactNode; value: string }>;
}) {
  return (
    <RadioGroupPrimitive.Root
      className={className}
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      {options.map((option) => (
        <label
          key={option.value}
          className="flex min-h-11 items-start gap-3 rounded-2xl border border-border bg-card px-4 py-3"
        >
          <RadioGroupPrimitive.Item
            className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-border"
            data-slot="interactive-control"
            value={option.value}
          >
            <RadioGroupPrimitive.Indicator className="h-2.5 w-2.5 rounded-full bg-primary" />
          </RadioGroupPrimitive.Item>
          <span className="space-y-1">
            <span className="block text-sm font-medium text-foreground">
              {option.label}
            </span>
            {option.description ? (
              <span className="block text-sm text-muted-foreground">
                {option.description}
              </span>
            ) : null}
          </span>
        </label>
      ))}
    </RadioGroupPrimitive.Root>
  );
}
